/** Application entry point that mounts the React root. */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { App } from '@/app/App';
import { store } from '@/app/store';
import { ErrorBoundary } from '@/shared/components/common/ErrorBoundary';
import { Toaster } from '@/shared/components/common/Toaster';
import '@/shared/utils/i18n';
import '@/shared/styles/globals.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <BrowserRouter>
          <App />
          <Toaster />
        </BrowserRouter>
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>
);
